<template>
	<div class="home">
		<div class="container" style="margin-bottom: 10px;">
			<div class="merchant-content">
				<div class="merchant-info">
					<div class="store-header">
						<img :src="storeInfo.storeLogo" class="store-avatar">
						<div class="store-name">
							<div class="store-name-left">
								<div class="store-name-left-child">
									<div style="display: flex; align-items: flex-start;">
										<div class="vip-tag-left">
											<img :src="storeInfo.memberConfigIcon?storeInfo.memberConfigIcon:'/icon/common/vip.svg'"
												style="width: 15px;">
											{{storeInfo.memberConfigName}}
										</div>
										<div class="store-name-text">{{storeInfo.storeName}}</div>
									</div>
									<div class="store-stats">
										<span>{{$t('fans')}}: {{storeInfo.collectionNum || 0}}</span>
										<span>{{$t('sold')}}: {{storeInfo.storeSales || 0}}</span>
									</div>
								</div>
								<div>
									<!-- 联系客服 -->
									<el-button type="primary" plain class="custom-btn">‌
										<i class="el-icon-s-promotion"></i> {{ $t('customerService') }}
									</el-button>
									<!-- 关注 -->
									<el-button type="warning" plain class="custom-btn" v-if="!isStoreCollection"
										@click="addStoreCollection" :loading="isSubmit">
										<i class="el-icon-plus"></i> {{ $t('follow') }}</el-button>
									<!-- 取消关注 -->
									<el-button type="warning" plain class="custom-btn" v-else
										@click="delStoreCollection" :loading="isSubmit">
										<i class="el-icon-minus"></i> {{ $t('unfollow') }}</el-button>
								</div>
							</div>
							<div class="store-desc">
								<el-tooltip class="item" placement="bottom">
									<div slot="content" style="max-width: 1200px;">
										{{storeInfo.storeDesc || ''}}
									</div>
									<div>{{storeInfo.storeDesc || ''}}</div>
								</el-tooltip>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="container">
			<!-- 查询输入框 -->
			<div class="search-container" :class="{ 'search-container-fixed': isSearchFixed }">
				<div class="search-wrapper">
					<div class="custom-search-input">
						<el-input type="text" :placeholder="$t('searchPlaceholder')" v-model="searchKeyword"
							class="search-input" @keyup.enter.native="search" />
						<button class="search-button" @click="search">{{ $t('storeSearchButton') }}</button>
					</div>
				</div>
			</div>

			<!-- 商家商品分类 -->
			<div>
				<div style="padding-bottom: 15px;" v-if="categoryLoading">
					<el-skeleton :loading="categoryLoading" animated :rows="3"></el-skeleton>
				</div>
				<div class="category-filters" v-if="!categoryLoading">
					<div v-for="category in categories" :key="category.id" class="category-filter"
						:class="{ active: category.active}" @click="handleCategorySelected(category)">
						{{ category.labelName }}
					</div>
				</div>
			</div>
			<!-- 查询条件区域 -->
			<div style="margin-top: -20px;">
				<ProductSearchFilter ref="productSearchFilter" :is-fixed="false" module="store_product"
					@filter-change="handleFilterChange" />
			</div>
			<!-- 商品列表 -->
			<div>
				<ProductList ref="productList" :store-category-id="selectCategoryId" :store-id="storeId"
					:keyword="searchKeyword" :brand="brand" :platform="platform" :price-range="priceRange"
					:shipping="shipping" :sort-by="sortBy" :scroll-top="isSearchFixed?280:0" source="merchant" />
			</div>
		</div>
		<RightFixedPanel @openEnquiry="enquiryDialogVisible = true" @openComplaint="complaintDialogVisible = true"
			show-complaint />

		<EnquiryDialog :visible.sync="enquiryDialogVisible" />

		<ComplaintDialog :visible.sync="complaintDialogVisible" :store-id="storeId" />

	</div>
</template>

<script>
	import merchantApi from '@/api/merchant';
	import collectionApi from '@/api/collection';
	import storage from "@/utils/storage.js";
	import ProductList from '@/components/ProductList.vue';
	import ProductSearchFilter from '@/components/ProductSearchFilter.vue'
	import CategoryTree from '@/components/CategoryTree.vue';
	import RightFixedPanel from '@/components/RightFixedPanel.vue';
	import EnquiryDialog from '@/components/EnquiryDialog.vue';
	import ComplaintDialog from '@/components/ComplaintDialog.vue'
	export default {
		name: 'MerchantDetail',
		components: {
			ProductList,
			CategoryTree,
			ProductSearchFilter,
			RightFixedPanel,
			EnquiryDialog,
			ComplaintDialog
		},
		data() {
			return {
				isSubmit: false,
				isStoreCollection: false, //是否已关注
				categoryLoading: true,
				categories: [],
				storeId: '',
				storeInfo: {},
				searchKeyword: '',
				isSearchFixed: false,
				selectCategoryId: null, //选中的商品分类ID
				enquiryDialogVisible: false,
				complaintDialogVisible: false,
				brand: "all",
				platform: "all",
				priceRange: "all",
				shipping: "all",
				sortBy: "refresh_time",
				accessToken: storage.getToken()
			}
		},
		mounted() {
			this.storeId = this.$route.query.id;
			this.getStoreDetail();
			this.getStoreCategory();
			window.addEventListener('scroll', this.handleScroll)
			this.$once('hook:destroyed', () => {
				window.removeEventListener('scroll', this.handleScroll)
			})
			this.$nextTick(() => {
				//加载商品分类
				if (this.$refs.categoryTree && typeof this.$refs.categoryTree.init === 'function') {
					//this.$refs.categoryTree.init();
				}
				//加载代购平台
				if (this.$refs.productSearchFilter && typeof this.$refs.productSearchFilter.init === 'function') {
					this.$refs.productSearchFilter.init();
				}
				//加载商品信息
				this.loadGoods();
			});
			this.getIsStoreCollection();
		},
		methods: {
			handleFilterChange(filter) {
				this.brand = filter.brand;
				this.platform = filter.platform;
				this.priceRange = filter.priceRange;
				this.shipping = filter.shipping;
				this.sortBy = filter.sortBy;
				//加载商品信息
				setTimeout(() => {
					this.loadGoods();
				}, 200)
			},
			//获取商品详情
			async getStoreDetail() {
				const res = await merchantApi.getStoreDetail(this.storeId);
				this.storeInfo = res.result;
			},
			//获取商家商品分类
			async getStoreCategory() {
				const res = await merchantApi.getStoreCategory(this.storeId);
				this.categoryLoading = false;
				this.categories = res.result;
				this.categories.map(item => {
					item.active = false;
				})
				this.categories.unshift({
					id: 'all',
					active: true,
					labelName: this.$t('all')
				})
			},
			//加载商品列表
			loadGoods() {
				if (this.$refs.productList && typeof this.$refs.productList.init === 'function') {
					this.$refs.productList.init();
				}
			},
			handleScroll() {
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				// 简化滚动逻辑，不再依赖不存在的元素
				this.isSearchFixed = scrollTop > 260
			},
			search() {
				this.loadGoods();
			},
			// 处理分类选择
			handleCategorySelected(category) {
				this.categories.map(item => {
					item.active = false;
				})
				category.active = true;
				this.selectCategoryId = category.id;
				setTimeout(() => {
					this.loadGoods();
				}, 200)
			},
			//用户是否关注
			async getIsStoreCollection() {
				//获取当前登录用户是否有关注
				if (this.accessToken) {
					const res = await collectionApi.isStoreCollection(this.storeId);
					this.isStoreCollection = res.result;
				}
			},
			//关注商家
			async addStoreCollection() {
				if (!this.accessToken) {
					this.handleLogin();
				} else {
					this.isSubmit = true;
					const res = await collectionApi.addStoreCollection(this.storeId);
					this.isSubmit = false;
					if (res.code == 200) {
						this.isStoreCollection = true;
						this.$message.success(this.$t('followSuccess'))
					} else {
						this.$message.warning(this.$t('followFail'))
					}
				}
			},
			//取消关注
			async delStoreCollection() {
				if (!this.accessToken) {
					this.handleLogin();
				} else {
					this.isSubmit = true;
					const res = await collectionApi.delStoreCollection(this.storeId);
					this.isSubmit = false;
					if (res.code == 200) {
						this.isStoreCollection = false;
						this.$message.success(this.$t('followCancel'))
					} else {
						this.$message.warning(this.$t('followFail'))
					}
				}
			},
			handleLogin() {
				this.$confirm(this.$t('loginMessage'), this.$t('tip'), {
					confirmButtonText: this.$t('gotoLogin'),
					cancelButtonText: this.$t('closeLogin'),
					type: 'warning'
				}).then(() => {
					this.$router.push('/login')
				}).catch(() => {
					// 处理取消事件，避免报错
				})
			},
		}
	}
</script>

<style scoped>
	.home {
		width: 100%;
		background-image: linear-gradient(to bottom, #016AF8, #fff 70%);
		padding-top: 20px;
	}

	.custom-btn {
		padding: 12px 25px;
	}

	.merchant-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 0;
	}

	.merchant-info {
		position: relative;
		flex-shrink: 0;
		width: 100%;
	}

	.store-header {
		display: flex;
	}

	.store-avatar {
		width: 100px;
		height: 100px;
		border-radius: 10px;
		object-fit: cover;
		margin-right: 15px;
	}

	.store-name {
		flex: 1;
		min-width: 0;
		display: flex;
		justify-content: flex-start;
		flex-direction: column;
	}

	.store-name>div:first-child {
		display: flex;
		align-items: center;
		font-weight: 500;
		color: #333;
	}

	.store-name-text {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		font-weight: bold;
	}

	.store-name-left {
		display: flex;
		width: 100%;
		justify-content: space-between;
		align-items: flex-start;
	}

	.store-name-left-child {
		width: 68%;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}

	.store-stats {
		display: flex;
		font-size: 13px;
		color: #999;
		margin: 10px 0;
	}

	.store-desc {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		font-size: 14px;
		color: #999;
	}

	.store-stats span {
		margin-right: 15px;
	}

	.search-container.search-container-fixed {
		position: fixed !important;
		top: 0px !important;
		left: 0 !important;
		right: 0 !important;
		bottom: auto !important;
		z-index: 10000 !important;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
	}

	.search-container.search-container-fixed .custom-search-input {
		width: 71%;
	}

	.category-filters-fixed {
		position: fixed !important;
		top: 60px !important;
		left: 0;
		right: 0;
		z-index: 999;
		background-color: #f2f2f2;
		padding: 0 !important;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		justify-content: flex-start;
		overflow-x: auto;
		justify-content: center;
		/* 默认隐藏滚动条 */
		scrollbar-width: thin;
		scrollbar-color: transparent transparent;
	}

	/* 鼠标移入时显示滚动条 */
	.category-filters-fixed:hover {
		scrollbar-color: #ccc transparent;
	}

	/* WebKit浏览器滚动条样式 */
	.category-filters-fixed::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}

	.category-filters-fixed::-webkit-scrollbar-track {
		background: transparent;
	}

	.category-filters-fixed::-webkit-scrollbar-thumb {
		background-color: transparent;
		border-radius: 3px;
	}

	.category-filters-fixed:hover::-webkit-scrollbar-thumb {
		background-color: #ccc;
	}

	.search-wrapper {
		background-color: #fff;
		padding: 10px 0;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		gap: 10px;
	}

	/* Responsive adjustments */
	@media (max-width: 992px) {
		.custom-search-input {
			width: 70%;
		}
	}

	@media (max-width: 768px) {
		.search-wrapper {
			flex-direction: column;
			gap: 15px;
		}

		.custom-search-input {
			width: 100%;
		}

		.search-input {
			font-size: 14px;
		}

		.search-button {
			font-size: 14px;
			height: 36px;
			padding: 0 15px;
		}
	}

	@media (max-width: 480px) {
		.search-wrapper {
			padding: 15px;
		}
	}

	.custom-search-input {
		display: flex;
		align-items: center;
		border-radius: 10px;
		width: 100%;
		overflow: hidden;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		border: 2px solid #F59A23;
		background-color: rgba(0, 0, 0, 0.05);
		height: 40px;
	}

	.search-button {
		background-color: #F59A23;
		color: white;
		border: none;
		height: 60px;
		width: 180px;
		cursor: pointer;
		font-size: 17px;
		transition: background-color 0.3s;
		line-height: 60px;
	}

	:deep .el-input__inner {
		background-color: transparent !important;
		border: 0 solid #DCDFE6;
		font-size: 16px;
		color: #333;
	}

	.search-button:hover {
		background-color: #F59A23;
	}

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 10px 20px;
		background-color: #fff;
		border-radius: 10px;
	}

	.category-filters {
		display: flex;
		margin-bottom: 30px;
		flex-wrap: nowrap;
		overflow-x: auto;
		padding: 10px 0;
		/* 默认隐藏滚动条 */
		scrollbar-width: thin;
		scrollbar-color: transparent transparent;
	}

	/* 鼠标移入时显示滚动条 */
	.category-filters:hover {
		scrollbar-color: #ccc transparent;
	}

	/* WebKit浏览器滚动条样式 */
	.category-filters::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}

	.category-filters::-webkit-scrollbar-track {
		background: transparent;
	}

	.category-filters::-webkit-scrollbar-thumb {
		background-color: transparent;
		border-radius: 3px;
	}

	.category-filters:hover::-webkit-scrollbar-thumb {
		background-color: #ccc;
	}

	.category-filter {
		padding: 20px 30px;
		background-color: #f5f5f5;
		color: #333;
		cursor: pointer;
		font-size: 17px;
		transition: all 0.3s ease;
		flex-shrink: 0;
		white-space: nowrap;
	}

	.category-filter.active {
		background-color: #016AF8;
		font-weight: bold;
		color: white;
	}

	.category-filter:hover {
		background-color: #E6F1FE;
		color: #016AF8;
	}

	.category-filter.active:hover {
		background-color: #0156c8;
		color: #fff;
	}

	@media (max-width: 768px) {
		.category-filters {
			gap: 10px;
		}

		.category-filter {
			padding: 6px 12px;
			font-size: 12px;
		}
	}

	@media (max-width: 768px) {
		.banner-text {
			font-size: 14px;
		}
	}
</style>